import angular from 'angular';
import ProcessMapViewBridge from '../bridges/ProcessMapViewBridge';

angular
  .module('flowingly.runner.processmapsv2')
  .component('processMapsV2View', ProcessMapViewBridge);
